import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Icon from "../components/Icon";
import { AuditBlock } from "../components/SignOff";
import ReportActions from "../components/ReportActions";
import { apiGet } from "../api";
import { formatDateTime, formatStamp } from "../dateutil";
import { C, R, S } from "../theme";

const roleLabel = (r) => (r === "public" ? "Member of public" : r === "staff" ? "Staff member" : "-");

export default function IncidentDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [i, setI] = useState(null);
  useEffect(() => { apiGet(`/incidents/${id}`).then(setI); }, [id]);
  if (!i) return <div style={{ color: C.amber, textAlign: "center", paddingTop: 80 }}>Loading…</div>;
  const row = (l, v) => <div style={{ display: "flex", justifyContent: "space-between", padding: `${S.sm}px 0`, borderBottom: `1px solid ${C.border}` }}><span style={{ color: C.muted }}>{l}</span><span style={{ color: C.text, fontWeight: 700, textAlign: "right", marginLeft: S.md }}>{v}</span></div>;
  return (
    <div className="fade-up">
      <div style={{ display: "flex", alignItems: "center", gap: S.sm, padding: S.lg }}>
        <button className="pressable" onClick={() => nav(-1)}><Icon name="chevron-back" size={28} color={C.text} /></button>
        <div className="display" style={{ color: C.text, fontSize: 20, fontWeight: 900 }}>Incident Record</div>
      </div>
      <div style={{ padding: S.lg }}>
        <div style={{ display: "flex", alignItems: "center", gap: S.sm, background: C.card2, borderRadius: R.md, padding: S.md, marginBottom: S.md }}><Icon name="lock-closed" size={16} color={C.green} /><span style={{ color: C.green, fontWeight: 700, fontSize: 13 }}>Permanent legal record</span></div>
        <div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}` }}>
          {row("Attraction", i.attraction_name)}{row("Injured", i.injured_name)}
          {i.injured_role && row("Injured is", roleLabel(i.injured_role))}
          {i.injured_contact && row("Contact", i.injured_contact)}{row("Occurred", formatDateTime(i.occurred_at))}
          {i.location && row("Location", i.location)}
          {i.weather_conditions && row("Weather / ground", i.weather_conditions)}
          {i.staff_on_duty && row("Staff on duty", i.staff_on_duty)}
          {i.witnesses && row("Witnesses", i.witnesses)}
          {i.witness_contact && row("Witness contact", i.witness_contact)}
        </div>
        <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Description</div>
        <div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}`, color: C.text, lineHeight: 1.5 }}>{i.description}</div>
        {!!i.first_aid && (<><div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>First Aid Administered</div><div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}`, color: C.text, lineHeight: 1.5 }}>{i.first_aid}</div></>)}
        {(i.photos || []).map((p, idx) => <img key={idx} src={p} alt="" style={{ width: "100%", borderRadius: R.md, marginTop: S.md }} />)}
        <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Operator Sign-Off</div>
        <AuditBlock signature={i.signature} name={i.signed_by_name} initials={i.signed_by_initials} submittedAt={i.created_at} />
        <div style={{ height: S.md }} />
        <ReportActions report={{
          title: `Accident Report — ${i.attraction_name}`,
          company: i.attraction_name,
          rows: [], columns: [],
          photos: (i.photos || []).map((p, idx) => ({ label: `Evidence ${idx + 1}`, dataUri: p })),
          meta: {
            details: [
              { label: "Attraction", value: i.attraction_name }, { label: "Injured", value: i.injured_name },
              { label: "Injured is", value: i.injured_role ? roleLabel(i.injured_role) : null }, { label: "Contact", value: i.injured_contact },
              { label: "Occurred", value: formatDateTime(i.occurred_at) }, { label: "Location", value: i.location },
              { label: "Weather / ground", value: i.weather_conditions }, { label: "Staff on duty", value: i.staff_on_duty },
              { label: "Witnesses", value: i.witnesses }, { label: "Witness contact", value: i.witness_contact },
              { label: "First aid", value: i.first_aid }, { label: "Description", value: i.description },
            ],
            signature: i.signature, signedBy: i.signed_by_name, initials: i.signed_by_initials, submittedAt: formatStamp(i.created_at),
            docType: "IR", recordId: i.id, siteLocation: i.location, attractionName: i.attraction_name,
          },
        }} />
        <div style={{ height: S.xxl }} />
      </div>
    </div>
  );
}
